module.exports = __webpack_public_path__ + "static/img/workPassCn.c73449cc.png";